"use client";

import React from "react";
import { FileManagerContent } from "@/components/fileManager/FileManagerContent";

export default function FileManagerPage() {
  return (
    <div className="h-full flex flex-col">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold text-foreground">Assets</h1>
        <p className="text-sm text-muted-foreground mt-1">Manage your store assets, upload files, and organize folders</p>
      </div>

      <div className="flex-1 min-h-0">
        <FileManagerContent
          mode="fullscreen"
          config={{ selectionMode: "multiple", showUpload: true, showCreateFolder: true }}
          className="h-full"
        />
      </div>
    </div>
  );
}
